<template>
  <div>
    <a-modal title="Please Enter Income Info" :visible="modal_income_visible" @ok="submit_create"
      @cancel="modal_income_visible = false">
      <a-form layout="horizontal" width="300">
        <a-form-item label="Vessel:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-select showSearch style="width: 300px" :showArrow="false" :filterOption="false" @search="on_search_vessel"
            v-model="payout_to_create.vessel_id">
            <a-select-option v-for="v in vsl_suggested" :key="v.id" :value="v.id">{{ v.vessel_ref }}--{{ v.vessel_name
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Date:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-date-picker size="small" v-model="payout_to_create.date_obj" />
        </a-form-item>

        <a-form-item label="Items:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-auto-complete :dataSource="item_suggested" style="width: 300px" @search="on_search_items"
            v-model="payout_to_create.items" />
        </a-form-item>

        <a-form-item label="Beneficiary:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-auto-complete :dataSource="bene_suggested" style="width: 300px" @search="on_search_bene"
            v-model="payout_to_create.beneficiary" />
        </a-form-item>

        <a-form-item label="Amount:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input size="small" type="number" step="0.01" v-model="payout_to_create.amount" />
        </a-form-item>

        <a-form-item label="Remarks:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input size="small" v-model="payout_to_create.remarks" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-button :style="{ marginBottom: '30px', marginRight: '20px' }" type="primary"
      @click="modal_income_visible = true">Create</a-button>
    <a-button :style="{ marginBottom: '30px' }" type="primary" @click="modal_send_emails = true">Send selected rows as
      emails</a-button>
    <download-excel :data="table_data" :fields="payout_export_field" style="display: inline; margin-left: 30px">
      <a-button type="primary">Export EXCEL</a-button>
    </download-excel>
    <a-button type="link"> version:2024-7-03 </a-button>

    <a-modal title="Please Enter Income Info" :visible="modal_send_emails" okText="Send" @ok="send_mail"
      @cancel="modal_send_emails = false" width="60%">
      <a-form layout="horizontal">
        <a-form-item label="Subject:" :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          <a-input size="small" type="text" v-model="email_draft.subject" />
        </a-form-item>
        <a-form-item label="Sender:" :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          luwt@comergegroup.com
        </a-form-item>
        <a-form-item label="Recipients:" :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          {{ email_draft.to }}
        </a-form-item>
        <a-form-item label="CC:" :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          {{ email_draft.cc }}
        </a-form-item>

        <a-form-item label="Attachments" :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          payment ID:{{ email_draft.payout_id }}
        </a-form-item>

        <a-form-item label=" " :labelCol="{ span: 3 }" :wrapperCol="{ span: 21 }" style="margin-bottom: 3px">
          <wysiwyg style="min-height: 500px" v-model="email_draft.content_html" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-table size="small" :dataSource="table_data" :columns="columns" rowKey="id"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="{ showSizeChanger: true, pageSizeOptions: ['10', '100'] }">
      <div slot="text_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px">
        <a-input v-ant-ref="(c) => (item_search_input = c)" :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]" @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => confirm()" style="width: 188px; margin-bottom: 8px; display: block" />
        <a-button type="primary" @click="() => confirm()" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>
        <a-button @click="() => clearFilters()" size="small" style="width: 90px">Reset</a-button>
      </div>
      <div slot="date_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters }"
        style="padding: 8px">
        <a-range-picker size="small" style="width: 200px; margin-bottom: 8px; display: block"
          v-ant-ref="(c) => (date_range_input = c)" v-model="search_date_range"
          @change="setSelectedKeys(search_date_range)" />
        <a-button @click="confirm" type="primary" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>

        <a-button @click="clearFilters" size="small" style="width: 90px; margin-left: 8px">Reset</a-button>
      </div>
      <!-- Income Data Display and Edit -->
      <div v-for="col in [
        'vessel_name',
        'items',
        'date',
        'beneficiary',
        'amount',
        'remarks',
        'paid',
      ]" :slot="col" slot-scope="text, record" :key="col">
        <div style="text-align: center">
          <template v-if="record.editable">
            <a-select v-if="col == 'vessel_name'" :value="text" showSearch style="width: 150px" :showArrow="false"
              :filterOption="false" @search="on_search_vessel" @change="(e) => change_data(e, record, col)">
              <a-select-option v-for="v in vsl_suggested" :key="v.id">{{ v.vessel_ref }}/{{ v.vessel_name
              }}</a-select-option>
            </a-select>
            <div v-if="col == 'paid'" :value="text" :style="{ width: '50px' }" size="small">
              <span v-if="text == 'Y'">{{ text }}</span>
              <span v-else style="color: red; font-weight: 900">{{ text }}</span>
            </div>
            <a-auto-complete style="width: 200px" :dataSource="item_suggested" size="small" v-if="col == 'items'"
              @search="on_search_items" v-model="record.items" @change="(e) => change_data(e, record, col)" />
            <a-auto-complete style="width: 200px" :dataSource="bene_suggested" size="small" v-if="col == 'beneficiary'"
              @search="on_search_bene" v-model="record.beneficiary" @change="(e) => change_data(e, record, col)" />

            <a-input v-if="col == 'amount'" :value="text" size="small" type="number" step="0.01"
              @change="(e) => change_data(e.target.value, record, col)" />
            <a-input v-if="col == 'remarks'" :value="text" size="small"
              @change="(e) => change_data(e.target.value, record, col)" />
            <a-date-picker v-if="col == 'date'" size="small" v-model="record.date_obj"
              @change="(e) => change_data(e, record, col)" />
          </template>
          <template v-else>
            <template v-if="col == 'paid'">
              <div v-if="text == 'Y'">{{ text }}</div>
              <div v-else style="color: red; font-weight: 900">{{ text }}</div>
            </template>
            <template v-else-if="col == 'amount'">
              {{ formatUSD(text) }}
            </template>
            <template v-else>
              {{ text }}
            </template>
          </template>
        </div>
      </div>

      <template slot="audited" slot-scope="text">
        <div v-if="text == 'Y'">{{ text }}</div>
        <div v-else style="color: red; font-weight: 900">{{ text }}</div>
      </template>

      <template slot="final_audited" slot-scope="text">
        <div v-if="text == 'Y'">{{ text }}</div>
        <div v-else style="color: red; font-weight: 900">{{ text }}</div>
      </template>
      <template slot="creator" slot-scope="text">
        {{text ? users.filter((u) => u.id == text)[0].account : "N/A"}}
      </template>
      <!-- Operations -->
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations" style="text-align: center">
          <span v-if="record.editable">
            <a-popconfirm title="About to Save?" @confirm="() => save(record.id)">
              <a>Save</a>
            </a-popconfirm>

            <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.id)">
              <a>Cancel</a>
            </a-popconfirm>
          </span>

          <span v-else>
            <a @click="() => edit(record.id)">Edit</a>
            <a-popconfirm title="Sure to Delete?" @confirm="() => delete_record(record.id)">
              <a>Delete</a>
            </a-popconfirm>
            <!-- signed  -->
            <a-popconfirm v-if="userinfo.group == 'book-keeper'" @confirm="() => Sign_1st(record.id)"
              title="Correct Sure?">
              <a>1<span style="vertical-align: super">st</span>Sign</a>
            </a-popconfirm>
            <a-popconfirm v-if="userinfo.group == 'book-checker'" @confirm="() => Sign_2nd(record.id)"
              title="Correct Sure?">
              <a>2<span style="vertical-align: super">nd</span>Sign</a>
            </a-popconfirm>
            <a-popconfirm v-if="userinfo.group == 'admin'" @confirm="() => Sign_1st(record.id)" title="Correct Sure?">
              <a>1<span style="vertical-align: super">st</span>Sign</a>
            </a-popconfirm>
            <a-popconfirm v-if="userinfo.group == 'admin'" @confirm="() => Sign_2nd(record.id)" title="Correct Sure?">
              <a>2<span style="vertical-align: super">nd</span>Sign</a>
            </a-popconfirm>
            <!-- signed  -->
            <a-popconfirm title="Print with?" okText="USD" cancelText="RMB" @confirm="printUSD(record.id, record.sq)"
              @cancel="printRMB(record.id, record.sq)">
              <a>Print</a>
            </a-popconfirm>
          </span>
        </div>
      </template>

      <template slot="upload" slot-scope="text, record">
        <a-upload-dragger size="small" name="file" :multiple="true" @change="(info) => change_upload(record, info)"
          :fileList="record.attachments" :action="$store.state.base_url + '/upload'" :headers="headers">
          <p>
            <a-icon type="inbox" />
          </p>
          <p>Click or drag file to this area to upload</p>
        </a-upload-dragger>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import userinfo from "../utils/userinfo.js";
import users_filter from "./users_filter.js";
import { formatUSD } from "../utils/format_currency.js";

const payout_export_field = {
  ID: "id",
  "Vessel Ref": "vessel_ref",
  "Vessel Name": "vessel_name",
  Date: "date",
  Item: "item",
  Beneficiary: "beneficiary",
  Amount: "amount",
  Remarks: "remarks",
  Paid: "paid",
  Audited: "audited",
  "Final Audited": "final_audited",
};

export default {
  name: "payout",
  data() {
    // ES7 deep copy syntax ... will interate and deep copy an object's prop or element of array
    this.cacheData = [];
    return {
      headers: {
        access_token: userinfo.get().access_token,
      },

      userinfo: userinfo.get(),

      beneficiary_list: [],
      item_list: [],

      users: [],
      vessels: [],
      table_data: [],
      columns: [
        {
          title: "ID#",
          dataIndex: "id",
          align: "center",
          sortOrder: "descend",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Vessel_Ref",
          dataIndex: "vessel_ref",
          align: "center",
          scopedSlots: {
            customRender: "vessel_ref",
          },
        },
        {
          title: "Vessel_Name",
          dataIndex: "vessel_name",
          align: "center",
          scopedSlots: {
            customRender: "vessel_name",
          },
          onFilter: (value, record) => {
            return record.vessel_ref.toLowerCase().includes(value.toLowerCase())
          },
        },
        {
          title: "Creator",
          dataIndex: "creator",
          align: "center",
          scopedSlots: { customRender: "creator" },
          onFilter: (value, record) => {
            if (record.creator) {
              return record.creator == value
            } else {
              return false
            }
          },
          filters: users_filter
        },
        {
          title: "Date",
          dataIndex: "date",
          align: "center",
          scopedSlots: {
            filterDropdown: "date_filter",
            customRender: "date",
          },
          onFilter: (value, record) => {
            var date = moment(record.date).set({
              hour: 12,
              minute: 0,
              second: 0,
            });
            var start = this.search_date_range[0].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            var end = this.search_date_range[1].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            if (date.isBetween(start, end, "day", "[]")) {
              return true;
            } else {
              return false;
            }
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.date_range_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Items",
          dataIndex: "items",
          align: "center",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "items",
          },
          onFilter: (value, record) =>
            record.items.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Beneficiary",
          dataIndex: "beneficiary",
          align: "center",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "beneficiary",
          },
          onFilter: (value, record) =>
            record.beneficiary.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          align: "center",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "amount",
          },
          sorter: (a, b) => a.id - b.id,
          onFilter: (value, record) =>
            record.amount.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Remarks",
          dataIndex: "remarks",
          align: "center",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "remarks",
          },
          onFilter: (value, record) =>
            record.remarks.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Paid?",
          dataIndex: "paid",
          align: "center",
          scopedSlots: {
            customRender: "paid",
          },
          onFilter: (value, record) => {
            if (record.editable) {
              return true;
            }
            return record.paid.toLowerCase().includes(value.toLowerCase());
          },
          filters: [
            { text: "Yes", value: "Y" },
            { text: "No", value: "N" },
          ],
        },
        {
          title: "Upload",
          align: "center",
          dataIndex: "upload",
          scopedSlots: { customRender: "upload" },
        },
        {
          title: "operation",
          align: "center",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      selectedRowKeys: [],
      payout_export_field: payout_export_field,
      // send emails
      modal_send_emails: false,
      email_draft: {
        subject: "Payment Nofication",
        to: ["ops@comergegroup.com"],
        cc: [
          "document@comergegroup.com",
          "acct@comergegroup.com",
          "acctcomerge@protonmail.com",
        ],
        // cc: ["document@comergegroup.com", "ops@comergegroup.com"],
        content_html: "<html></html>",
        payout_id: [],
      },

      // filter controls and data holder
      item_search_input: null,
      search_date_range: [],
      date_range_input: null,

      //create modal
      modal_income_visible: false,
      payout_to_create: {
        paid: "false",
      },

      payment_seq: [],

      // auto complete
      vsl_suggested: [],
      item_suggested: [],
      bene_suggested: [],

      vsl_search_flag: false,
    };
  },
  methods: {
    formatUSD,
    refresh() {
      var params = {};
      var vid = this.$route.params.vid;
      if (vid == "all") {
        params = {};
      } else {
        params.vessel_id = vid;
      }

      this.shipIDs = [];
      this.$http.post(this.$store.state.base_url + "/payout/r", params).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          data.forEach((d) => {
            d.vessel_ref = "MV" + (d.vessel_id + 10000 + "").substr(1, 4);
            d.date_obj = moment(d.date);
            d.paid = d.paid ? "Y" : "N";
            d.audited = d.audited ? "Y" : "N";
            d.sq = this.gen_py_sq(d);
            d.final_audited = d.final_audited ? "Y" : "N";
          });
          // set cacheData and table_data
          this.cacheData = data.map((item) => ({ ...item }));
          this.table_data = data;

          // get suggestion list
          this.get_suggestion_list();
        }
      });
    },

    gen_py_sq(d) {
      var found = this.payment_seq.findIndex((pysq) => {
        return pysq.vessel_id == d.vessel_id;
      });
      if (found == -1) {
        this.payment_seq.push({
          vessel_id: d.vessel_id,
          count: 1,
        });
        return 1;
      } else {
        this.payment_seq[found].count = this.payment_seq[found].count + 1;
        return this.payment_seq[found].count;
      }
    },

    get_vesesl_list() {
      this.vessels = [];
      this.$http.post(this.$store.state.base_url + "/vessel/r", {}).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          this.columns[2].filters = [];
          data.forEach((d) => {
            d.vessel_ref = "MV" + (d.id + 10000 + "").substr(1, 4);
            this.columns[2].filters.push({
              text: d.vessel_name,
              value: d.vessel_ref,
            });
          });
          this.vessels = data;
        }
      });
    },

    get_suggestion_list() {
      this.beneficiary_list = [];
      this.item_list = [];

      this.table_data.forEach((d) => {
        var i = this.beneficiary_list.findIndex((m) => m == d.beneficiary);
        if (i == -1) {
          this.beneficiary_list.push(d.beneficiary);
        }
        var j = this.item_list.findIndex((itm) => itm == d.items);
        if (j == -1) {
          this.item_list.push(d.items);
        }
      });
    },
    // table edit function
    edit(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.table_data = newData;
      }
    },
    change_data(value, record, col) {
      console.log("Value Changed:", value);
      const newData = [...this.table_data];
      const target = newData.filter((item) => record.id === item.id)[0];
      if (target) {
        switch (col) {
          case "vessel_name":
            var new_v = this.vessels.filter((item) => value == item.id)[0];
            target["vessel_name"] = new_v.vessel_name;
            target["vessel_ref"] = "MV" + (value + 10000 + "").substr(1, 4);
            target["vessel_id"] = value;
            break;
          case "items":
            target["items"] = value;
            break;
          case "beneficiary":
            target["beneficiary"] = value;
            break;
          case "date":
            target[col] = value.format("YYYY-MM-DD");
            break;
          default:
            target[col] = value;
            break;
        }
      }
      this.table_data = newData;
    },
    save(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      // net work operation hare
      // success and fails

      console.log("Save to Server");
      var data = JSON.parse(JSON.stringify(target));
      delete data.vessel_ref;
      data.paid = data.paid == "Y" ? true : false;
      data.audited = data.audited == "Y" ? true : false;
      data.final_audited = data.final_audited == "Y" ? true : false;

      delete data.date_obj;
      delete data.lasteditor;
      delete data.lastupdate;
      delete data.vessel_name;
      this.$http.post(this.$store.state.base_url + "/payout/u", data).then((res) => {
        if (res.data.status == 1) {
          this.$message.info(res.data.msg);
          delete target.editable;
          this.table_data = newData;
          this.cacheData = newData.map((item) => ({ ...item }));
        }
      });
    },
    cancel(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.id)[0]);
        delete target.editable;
        this.table_data = newData;
      }
    },
    change_upload(record, info) {
      if (info.file.status === "done") {
        for (var i = 0; i < info.fileList.length; i++) {
          if (
            info.fileList[i].hasOwnProperty("percent") &
            (info.fileList[i].percent == 100)
          ) {
            var tmp = {};
            tmp.name = info.fileList[i].name;
            tmp.filename = info.fileList[i].name;
            tmp.uid = info.fileList[i].response.data[0].path;
            tmp.path = info.fileList[i].response.data[0].path;
            tmp.url = this.$store.state.site_url + info.file.response.data[0].path;
            tmp.status = "done";
            info.fileList[i] = tmp;
          }
        }
        record.attachments = info.fileList;
        var r = JSON.parse(JSON.stringify(record));
        r.paid = r.paid == "Y" ? true : false;
        this.$http.post(this.$store.state.base_url + "/payout/u", r).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
          }
        });
        return;
      }
      if (info.file.status === "removed") {
        console.log("removed");
        record.attachments = info.fileList;
        r = JSON.parse(JSON.stringify(record));
        r.paid = r.paid == "Y" ? true : false;

        this.$http.post(this.$store.state.base_url + "/payout/u", r).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
          }
        });
      }
      console.log("fileList=>attachments");
      record.attachments = info.fileList;
    },

    printUSD(id, sq) {
      this.$router.push({ path: "/pUSD/" + id + "/" + sq });
    },

    printRMB(id, sq) {
      this.$router.push({ path: "/pRMB/" + id + "/" + sq });
    },

    // data submit function
    delete_record(id) {
      this.$http
        .post(this.$store.state.base_url + "/payout/d", { id: id })
        .then((res) => {
          if (res.data.status == 1) {
            var index = this.table_data.findIndex((e) => {
              return e.id == id;
            });

            // delete and update data
            var newData = [...this.table_data];
            newData.splice(index, 1);
            this.table_data = newData;
            this.cacheData = newData.map((item) => ({ ...item }));
          }
        });
    },
    submit_create() {
      delete this.payout_to_create.date_obj;
      this.$http
        .post(this.$store.state.base_url + "/payout/c", this.payout_to_create)
        .then((res) => {
          if (res.data.status == 1) {
            this.modal_income_visible = false;
            this.payout_to_create = {
              paid: "false",
            };

            this.refresh();
          }
        });
    },

    Sign_1st(id) {
      this.$http
        .post(this.$store.state.base_url + "/payout/u", { id: id, audited: true })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
    Sign_2nd(id) {
      this.$http
        .post(this.$store.state.base_url + "/payout/u", { id: id, final_audited: true })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },

    // on row select
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.email_draft.payout_id = selectedRowKeys;

      var payouts = [];
      if (selectedRowKeys.length !== 0) {
        selectedRowKeys.forEach((s) => {
          this.table_data.forEach((t) => {
            if (t.id == s) {
              payouts.push(t);
            }
          });
        });
      }
      this.email_draft.content_html = "";

      this.email_draft.subject = "Payment Notice - (";

      payouts.forEach((p) => {
        this.email_draft.subject =
          this.email_draft.subject +
          "MV0" +
          p.vessel_id +
          "/" +
          p.vessel_name +
          "/" +
          this.formatUSD(p.amount) +
          " , ";

        var print_flag = "pUSD/";
        if (p.remarks !== "") {
          print_flag = "pRMB/";
        }

        this.email_draft.content_html =
          this.email_draft.content_html +
          "<tr>" +
          "<td>" +
          p.id +
          "</td>" +
          "<td>" +
          p.sq +
          "</td>" +
          "<td>" +
          p.vessel_ref +
          "</td>" +
          "<td>" +
          p.vessel_name +
          "</td>" +
          "<td>" +
          p.date +
          "</td>" +
          "<td>" +
          p.beneficiary +
          "</td>" +
          "<td>" +
          p.items +
          "</td>" +
          "<td>" +
          this.formatUSD(p.amount) +
          "</td>" +
          "<td>￥" +
          p.remarks +
          "</td>" +
          // + "<td><a href='" + "http://localhost:8080/" + "#/" +print_flag + p.id + "/" + p.sq + "'" + ">click here</a></td>"
          "<td><a href='" +
          "http://v.comergegroup.com/" +
          "#/" +
          print_flag +
          p.id +
          "/" +
          p.sq +
          "'" +
          ">click here</a></td>";

        this.email_draft.content_html = this.email_draft.content_html + "<td>";
        p.attachments.forEach((a) => {
          this.email_draft.content_html =
            this.email_draft.content_html +
            "<a href='" +
            a.url +
            "'>" +
            a.filename +
            "</a><br>";
        });
        this.email_draft.content_html = this.email_draft.content_html + "</td>";
      });

      this.email_draft.subject = this.email_draft.subject.substr(
        0,
        this.email_draft.subject.length - 2
      );

      this.email_draft.subject = this.email_draft.subject + ")";
      if (this.email_draft.subject.length > 128) {
        this.email_draft.subject = this.email_draft.subject.substr(0, 120) + "...";
      }

      this.email_draft.content_html =
        "<html><table border = '1'>" +
        "<tr><td>ID</td><td>Sequnce</td><td>Vessel REF</td><td>Vessel Name</td><td>Date</td><td>Beneficiary</td><td>Items</td><td>Amount</td><td>Remarks</td><td>Payment Notice Link</td><td>Attachments</td></tr>" +
        this.email_draft.content_html +
        "</table></html>";
    },

    // auto complete function
    on_search_vessel(value) {
      if ((value !== "") & (value.length >= 3)) {
        this.vsl_suggested = this.vessels.filter((v) => {
          return v.vessel_name.toUpperCase().includes(value.toUpperCase());
        });
      }
    },

    on_search_items(value) {
      if ((value !== "") & (value.length >= 2)) {
        this.item_suggested = this.item_list.filter((i) => {
          return i.toUpperCase().includes(value.toUpperCase());
        });
      }
    },
    on_search_bene(value) {
      if ((value !== "") & (value.length >= 2)) {
        this.bene_suggested = this.beneficiary_list.filter((b) => {
          return b.toUpperCase().includes(value.toUpperCase());
        });
      }
    },

    send_mail() {
      this.$http
        .post(this.$store.state.base_url + "/sendmail", this.email_draft)
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Send Emails Success");
            this.modal_send_emails = false;
          }
        });
    },
  },

  mounted() {
    this.refresh();
    this.get_vesesl_list();
    this.$http.post(this.$store.state.base_url + "/user/r", {}).then((res) => {
      if (res.data.status == 1) {
        var data = res.data.data;
        this.users = data;
      }
    });
  },
  watch: {
    payout_to_create() {
      if (this.payout_to_create.date_obj) {
        this.payout_to_create.date = this.payout_to_create.date_obj.format("YYYY-MM-DD");
      }
    },
    $route: {
      deep: true,
      handler() {
        this.refresh();
      },
    },
  },
};
</script>
<style>
.editable-row-operations a {
  margin-right: 8px;
}

.ant-upload-list-item {
  width: 250px;
}
</style>
